import { literal, object, TypeOf } from 'zod';

import { ElementType } from '../common';

/* ----------------------------- AToZPageElement ---------------------------- */

export const AToZPageElement = object({
    type: literal(ElementType.AToZ),
});

export type AToZPageElement = TypeOf<typeof AToZPageElement>;
